import { render, staticRenderFns } from "./indexCSG.vue?vue&type=template&id=71ac1b41&scoped=true"
import script from "./indexCSG.vue?vue&type=script&lang=js"
export * from "./indexCSG.vue?vue&type=script&lang=js"
import style0 from "./indexCSG.vue?vue&type=style&index=0&id=71ac1b41&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac1b41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ac1b41')) {
      api.createRecord('71ac1b41', component.options)
    } else {
      api.reload('71ac1b41', component.options)
    }
    module.hot.accept("./indexCSG.vue?vue&type=template&id=71ac1b41&scoped=true", function () {
      api.rerender('71ac1b41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/report/sale/census/indexCSG.vue"
export default component.exports